export default "__VITE_ASSET__5e154ec1__"